import IDocumentGroup = SPA.Realtor.IDocumentGroup;
import IDocument = SPA.Realtor.IDocument;

class DocumentManager
{
	private Files: IDocument[];

	private Groups: IDocumentGroup[];

	private LastUpdate: number;

	public constructor()
	{
		this.Files = [];
		this.Groups = [];
		this.LastUpdate = 0;
	}

	public setData(data: {files: IDocument[], groups: IDocumentGroup[], time: number})
	{
		this.Files = data.files;
		this.Groups = data.groups;
		this.LastUpdate = data.time;
	}

	public reset()
	{
		this.Files = [];
		this.Groups = [];
		this.LastUpdate = 0;
	}

	public getFiles()
	{
		return this.Files;
	}

	public getFilesInGroup(groupID: number)
	{
		const files = this.Files.filter((f) => f.group_id === groupID);

		return files;
	}

	public getGroups()
	{
		return this.Groups;
	}

	public getDefaultFile(DefaultID: number)
	{
		const file = this.Files.filter((f) => f.default_id === DefaultID);

		return file.length === 0 ? false : file[0];
	}

	public setDefaultFile(DefaultID: number, data: IDocument)
	{
		const file = this.getDefaultFile(DefaultID);
		if (file !== false)
		{
			const index = this.Files.indexOf(file);
			this.Files[index] = data;
		}
	}

	public getFile(FileID: number)
	{
		const file = this.Files.filter((f) => f.id === FileID);

		return file.length === 0 ? false : file[0];
	}

	public setFile(FileID: number, data: IDocument)
	{
		const file = this.getFile(FileID);
		if (file === false)
		{
			this.Files.push(data);
		} else {
			const index = this.Files.indexOf(file);
			this.Files[index] = data;
		}
	}

	public getGroup(GroupID: number)
	{
		const group = this.Groups.filter((g) => g.id === GroupID);

		return group.length === 0 ? false : group[0];
	}

	public getLastUpdate(): number
	{
		return this.LastUpdate;
	}
}
